import React from 'react';
import '../../App.css';
import Hero from "../Hero";

function StraightHair() {
    return (
        <>
          <h1> What is Straight Hair? </h1>
          <p> Also known as “Type 1,” straight hair develops its structure 
              from the shape of the cortex (this is the middle and thickest 
              layer of your hair shaft). The fibers of the hair are round, 
              allowing it to drop evenly on all sides of the scalp. 
              Straight hair is also defined by its protein structure and the 
              disulfide bonds that occur between those proteins. It has 
              little to no hook at the end of the follicle (bulb), which 
              keeps it from growing at an angle. Variations don’t normally 
              occur in straight hair, but they do in thick hair. In many cases, 
              hormones and certain medications will change the texture of the hair, 
              causing it to grow in a different way than how it was originally formed. 
          </p>
          </>
    );
}

export default StraightHair;